import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import * as MDICONS from '@material-ui/icons';
// import * as ROUTES from '../../../../constants/routes';
import styled from "styled-components";
import ReactModal from 'react-modal';
import QrReader from 'react-qr-reader'
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { setCurrentProjectId } from '../../../../store/actions/projectActions';
import JoinProjectCard from './JoinProjectCard';

// import QrcodeDecoder from 'qrcode-decoder';

const formLabelStyle = {
    fontSize: "16px",
    fontWeight: "bold",
};

const ScanButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

class JoinProjectPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showDecodeModal: false,
            showScannerModal: false,
            forceCloseModal: false,
        }
    }

    /// README: HANDLING PICTURE ADDITIONS
    onPictureAddHandler = (e) => {
        // if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
        //     if (e.target.files && e.target.files[0]) {
        //         let fileReader = new FileReader();
        //         fileReader.readAsDataURL(e.target.files[0]);
        //         fileReader.onload = (pr) => {
        //             let imgBase64String = pr.target.result;
        //             var qr = new QrcodeDecoder();
        //             qr.decodeFromImage(imgBase64String).then((res) => {
        //                 if (res) {
        //                     this.props.setCurrentProjectId(res.data);
        //                     this.setState({
        //                         forceCloseModal: true,
        //                     })
        //                 } else {
        //                     alert("Invalid QR code!")
        //                 }
        //             });
        //         };
        //     }
        // }
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 1) {
            const msg = 'Only 1 image can be attached with comment'
            e.target.value = null
            alert(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['image/jpeg', 'image/png', 'image/JPEG', 'image/PNG']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// README: QR SCANNER METHODS
    handleScan = data => {
        if (data) {
            this.props.setCurrentProjectId(data);
            this.setState({
                forceCloseModal: true,
            })
        }
    }

    handleError = err => {
        this.props.setCurrentProjectId(null);
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showScannerModal: true, showDecodeModal: false, forceCloseModal: false });
                break;
            }
            case 1: {
                this.setState({ showScannerModal: false, showDecodeModal: true, forceCloseModal: false });
                break;
            }
            default: {
                this.setState({ showScannerModal: false, showDecodeModal: false, forceCloseModal: false });
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showScannerModal: false, showDecodeModal: false, forceCloseModal: false });
                break;
            }
            case 1: {
                this.setState({ showScannerModal: false, showDecodeModal: false, forceCloseModal: false });
                break;
            }
            default: {
                this.setState({ showScannerModal: false, showDecodeModal: false, forceCloseModal: false });
            }
        }
    }

    componentDidMount() {
        //this.props.setCurrentProjectId(null);
    }

    render() {
        const { joinProject, themeColors, dashboardSidebarSize, modalStyles, modalWidth, modalTitleStyle,commons } = this.props;

        // render relevant card based on if project is found
        const relevantCardComponent = joinProject ?
            (<JoinProjectCard joinProject={joinProject} />)
            :
            (<div className="row">
                <div className="col">
                    <div className="card py-5 px-5" onClick={() => { this.handleOpenModal(0) }} role="button">
                        <p><MDICONS.ErrorOutline style={{ scale: "2" }} /></p>
                        <h3><div className="mt-3 mb-1">Press scan QR code to find a {commons.project}</div></h3>
                        <button className="btn btn-link btn-sm" onClick={() => { this.handleOpenModal(0) }}>Scan QR</button>
                    </div>
                </div>

                <div className="col">
                    {/* <div className="card py-5 px-5" onClick={() => { this.handleOpenModal(1) }} role="button">
                        <p><MDICONS.ErrorOutline style={{ scale: "2" }} /></p>
                        <h3><div className="mt-3 mb-1">Attach a QR</div></h3>
                        <button className="btn btn-link btn-sm" onClick={() => { this.handleOpenModal(1) }}>Attach QR</button>
                    </div> */}
                </div>
            </div>);

        return (
            <div className="container-fluid">
                <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                    {/* HEADER */}
                    <h5 className="card-header">
                        <div className="d-flex justify-content-between">
                            {/* LEFT SIDE HEADER ITEMS */}
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <MDICONS.DvrRounded className="mr-3" style={{ width: "40px", height: "40px" }} />
                                    <span style={{ fontWeight: "bold" }}>Join an existing {commons.project}</span>
                                </div>
                            </div>
                            {/* RIGHT SIDE HEADER ITEMS */}
                            {joinProject ?
                                <div className="d-flex flex-row">
                                    <div className="align-self-center pr-1">
                                        <ScanButton themeColors={themeColors}>
                                            <button className="btn btn-default btn-sm" onClick={() => { this.handleOpenModal(0) }}>
                                                <MDICONS.ScannerRounded /><span className="ml-2">Scan a qr code{joinProject ? " again?" : ""}</span>
                                            </button>
                                        </ScanButton>
                                    </div>
                                    <div className="align-self-center">
                                        <ScanButton themeColors={themeColors}>
                                            <button className="btn btn-default btn-sm" onClick={() => { this.handleOpenModal(1) }}>
                                                <MDICONS.AttachFile /><span className="ml-2">Attach a qr code{joinProject ? " again?" : ""}</span>
                                            </button>
                                        </ScanButton>
                                    </div>
                                </div> : <React.Fragment />}
                        </div>
                    </h5>

                    {/* BODY */}
                    <div className="container-fluid my-5">
                        {relevantCardComponent}
                    </div>
                </div>

                {/* SCANNER MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showScannerModal && !this.state.forceCloseModal === true}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Scanner cam"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm">
                            <QrReader
                                delay={300}
                                onError={this.handleError}
                                onScan={this.handleScan}
                                style={{ height: '100%' }}
                            />
                        </div>
                    </div>
                </ReactModal>

                {/* DECODE MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showDecodeModal && !this.state.forceCloseModal === true}
                    onRequestClose={() => { this.handleCloseModal(1) }}
                    contentLabel="Scanner cam"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm">
                            <p style={modalTitleStyle}>Scan a QR code</p>
                            <div className="p-3" style={{ maxHeight: '500px' }}>
                                <label style={formLabelStyle} className="mx-1 btn btn-sm btn-flat" htmlFor="newQrFiles" role="button"><MDICONS.AttachFile />Attach an image</label>
                                <input type="file" className="file" id="newQrFiles" hidden multiple onChange={this.onPictureAddHandler} />
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        commons:state.commons,
        proid: state.project.proid,

        userData: state.firebase.profile,
        joinProject: state.firestore.data.JoinProject,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        const proid = props.proid ?? "-1";
        return [
            {
                collection: "Projects",
                storeAs: "JoinProject",
                doc: proid,
            },
        ]
    })
)(JoinProjectPage);
